import React from 'react';
import { ReactComponent as CloseForm } from './images/close-message.svg';
import './ConfirmationMessage.css';

function ConfirmationMessage(props) {
  return (
    <div className="message-container">
      <div className="form-header">
        <div className="form-header-title">{props.title}</div>
        <button
          style={{ fontWeight: 'bolder' }}
          className="form-close-button"
          onClick={props.closeMessage}
        >
          <CloseForm style={{ height: '10px' }} />
        </button>
      </div>

      <div className="message-body">
        <div className="message-text">{props.text}</div>

        <div>
          <button
            type="submit"
            className="message-close-button"
            onClick={props.closeMessage}
          >
            Zatvori
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationMessage;
